export default __webpack_public_path__ + "static/media/faq-2.1a44f262.png";